import enUS from './en-us'
import fr from './fr'

export default {
  'en-us': enUS,
  'fr': fr
}
